import React from 'react';
import Analytics from 'services/utils/Analytics';
import Settings from 'services/config/Settings';
import fetchJSON from 'services/utils/fetchJSON';
import GroupId from 'services/utils/GroupId';

class QRdetector extends React.Component {
	componentDidMount = () => {
		if (this.props.match.params) {
			const groupId = this.props.match.params.groupId ? this.props.match.params.groupId : false;
			if (groupId) {
				Analytics('User used QR', { GroupId: groupId });
				fetchJSON(Settings.endpoindApi+'/api/v1/groups/get/'+groupId, {
					method: 'get',
					headers: {
						Source: 'QR'
					}
				}).then(data => {
					if (data.code === 200) {
						Analytics('Сorrect group id from QR', { GroupId: groupId });
						GroupId.add(groupId);
						this.props.history.push(`/station?id=${groupId}`);
					} else {
						this.goToFrontPage();
					}
				})
				.catch(error => {
					console.log(error);
					this.goToFrontPage();
				});
			} else {
				this.goToFrontPage();
			}
		} else {
			this.goToFrontPage();
		}
  }
  startSession = (groupId) => {

  }
  goToFrontPage() {
  	Analytics('Group id from QR is invalid');
  	this.props.history.push('/');
  }
  render() {
  	return null;
  }
  
}


export default QRdetector;